import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import './MarketCategoriesLastMonths.scss';
import { Paper, Typography, LinearProgress, Grid } from '@material-ui/core';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { QueryFilter, QUERY_FILTER_MARKET } from 'src/component/shared';

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoriesLastMonthsProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoriesLastMonthsState {
    customFilter: {
        isChart: boolean
    },
}

export interface IMarketCategoriesLastMonthsDataChart {
    [key: string]: any;
}

const MARKET_PUBLISHERS_LAST_MONTHS = gql`
query marketCategoriesLastMonths($customFilter:  MarketShareCustomFilter) {
    marketCategoriesLastMonths(marketShareCustomFilter: $customFilter) {
        provider,
        category,
        date,
        share_volume,
		volume,
  }
}
`;

const COLORS = ['#20B2AA', '#40E0D0', '#FFBB28', '#FF8042','#90EE90',
    '#FFB6C1','#FFA07A','#0088FE','#87CEFA','#778899','#B0C4DE',
    '#008080','#D8BFD8','#FF6347','#F5DEB3','#EE82EE','#00C49F'];

let providersList: string[] = [];
let dtList: string[] = [];
let category = "";

const MarketCategoriesLastMonthsDataChart = ({ data }: { data: any[] }) => {
    let ind = 0;
    return (
        <ResponsiveContainer width="100%" height={450}>
            <LineChart data={data} margin={{ top: 30, right: 20, left: 14, bottom: 10 }}>
                <CartesianGrid vertical={false} horizontal={false} />
                <XAxis dataKey="date" />
                <YAxis yAxisId="center" />
                <Tooltip content={<MarketCategoriesLastMonthsTooltipData />} />
                <Legend />
                {
                    providersList.map((provider) => {
                        const color = COLORS[ind];
                        ind += 1;
                        return (<Line key={`line_${provider}`} yAxisId="center" dataKey={`${provider}`} stroke={`${color}`} isAnimationActive={false} />)
                    })
                }
            </LineChart>
        </ResponsiveContainer>
    );
};

const MarketCategoriesLastMonthsTooltipData = (props: any) => {

    let content: IMarketCategoriesLastMonthsDataChart;

    props.payload !== null &&  props.payload !== 0 &&  props.payload.length > 0 ? content = props.payload[0].payload : content = {};


    if(content != null && content !== undefined) {
        providersList.sort((obj1 : any, obj2 : any) => {
            const shareVolume1 = content[obj1+`_share_volume`];
            const shareVolume2 = content[obj2+`_share_volume`];
            
            if (shareVolume1 > shareVolume2) {
                return -1;
            }
            if (shareVolume1 < shareVolume2) {
                return 1;
            }
            return 0;
        });
    }

    return (<div className="tooltip-box">
        <table>
            <tbody>
                <tr className="tooltip-text">
                    <td className="tooltip-title tooltip-category" colSpan={3}>{category}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Mês:</td><td className="tooltip-title" colSpan={2}>{content && content.date_label}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Editora</td><td className="tooltip-title">Share Volume</td><td className="tooltip-title">Volume</td>
                </tr>
                {
                    providersList.map((provider) => {
                        const shareVolume = content[provider+`_share_volume_label`];
                        const volume = content[provider+`_volume`];
                        if(volume != null && volume !== undefined && shareVolume != null && shareVolume !== undefined) {
                            return (
                                <tr className="tooltip-text" key={provider}>
                                    <td className="tooltip-content" >{provider}</td><td className="tooltip-content info">{shareVolume}</td><td className="tooltip-content info">{volume}</td>
                                </tr>
                            );
                        } else {
                            return null;
                        }
                    })
                }
            </tbody>
        </table>
    </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.marketCategoriesLastMonths && !!data.marketCategoriesLastMonths.length
}

export class MarketCategoriesLastMonths extends React.Component<IMarketCategoriesLastMonthsProps, IMarketCategoriesLastMonthsState> {
    constructor(props: IMarketCategoriesLastMonthsProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }
    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <Grid container={true} spacing={16} className="marketCategoriesLastMonths">
                <Grid item={true} xs={12} sm={12}>
                    <Query query={QUERY_FILTER_MARKET} notifyOnNetworkStatusChange={true}  >
                        {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                            const filter = QueryFilter.getFilterMarket(clientC, jsonFilter, [], false);
                            if(filter.customFilter && filter.customFilter.category && filter.customFilter.category.length > 0) {
                                return (
                                    <Query query={MARKET_PUBLISHERS_LAST_MONTHS} variables={filter}>
                                        {({ loading, error, data, client }) => {
                                            return this.dataToRend(data,loading);
                                        }}
                                    </Query>
                                );
                            } else {
                                return this.dataToRend(null,true);
                            }
                            

                        }}
                    </Query>
                </Grid>
            </Grid>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    Comparativo por volume
                </Typography>
                {
                    loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (<MarketCategoriesLastMonthsDataChart 
                            data={this.marketCategoriesLastMonthsDataChartMap(data.marketCategoriesLastMonths)} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }

    private marketCategoriesLastMonthsDataChartMap = (data: IMarketCategoriesLastMonthsDataChart[]) => {

        const mappedData: IMarketCategoriesLastMonthsDataChart[] = [];
        providersList= [];
        dtList = [];

        data.forEach(e => {

            let item: IMarketCategoriesLastMonthsDataChart = {};

            let isInsert = false;
            if(!dtList.includes(e.date)) {
                dtList.push(e.date);
                item = {
                    date: e.date,
                    date_label: e.date,
                };
                isInsert = true;
            } else {
                const filteredItem = mappedData.find((x:IMarketCategoriesLastMonthsDataChart) => x.date === e.date);
                if(filteredItem != null && filteredItem !== undefined) {
                    item = filteredItem;
                }
            }
            item[e.provider+'_share_volume'] = Number.parseFloat(e.share_volume.toString());
            item[e.provider+'_share_volume_label'] =  e.share_volume + " %";
            item[e.provider+'_volume'] =  e.volume;
            item[e.provider]= Number.parseFloat(e.share_volume.toString());

            category = e.category;

            if(isInsert) {
                mappedData.push(item);
            }
            if(!providersList.includes(e.provider)) {
                providersList.push(e.provider);
            }
            
        });
        return mappedData;
    }
}


// WEBPACK FOOTER //
// ./src/component/market/general/categories/last-months/MarketCategoriesLastMonths.tsx